module.exports = __webpack_public_path__ + "static/media/python-projects.491d6cce.png";